import React from 'react'
import { Pill } from '@myxplor/ui'

import migrateToXplor from '../migrate-to-xplor'
import active, { isInFuture } from '../active'
import ActiveFilter from '../../../../ui/active-filter'
import { recordActionsToDisplay } from '../../../../ui/gov-actions'
import RecordDisplayList from '../../../../ui/record-display-list'

const ensureArray = record => {
  return record instanceof Array ? record : [record]
}

const isPending = ({ details }) => details && details.Current === 'N' && isInFuture(details.DoE)

const actionsForRecord = ({ record }) => [migrateToXplor({ record })]

const GovPersonnelBadge = ({ record }) => (
  <ul>
    <li>
      <Pill>{record.ccms_relationship}</Pill>
    </li>
    {isPending(record) && (
      <li>
        <Pill warning>Pending</Pill>
      </li>
    )}
  </ul>
)

const GovPersonnelList = ({ gov_registration }) => (
  <ActiveFilter records={ensureArray(gov_registration.gov_person_registrations)} filterOn={active}>
    <RecordDisplayList
      name={`${gov_registration.care_type.toUpperCase()} Registration`}
      recordBadgesComponent={GovPersonnelBadge}
      showRaw
      pending={isPending}
      actionButtonsComponent={recordActionsToDisplay({
        actionsForRecord,
      })}
      recordBase="details"
      level1={[
        {
          key: 'SPPersonnelId',
          label: 'SP personnel ID',
        },
        {
          key: 'CCMSPersonnelId',
          label: 'CCMS personnel ID',
        },
      ]}
      level2={[
        {
          key: 'AuthorisationStatus',
          label: 'Authorisation status',
        },
        {
          key: 'LastUpdatedOn',
          label: 'Last updated on',
        },
        {
          key: 'Qualification1',
          label: 'Main qualification',
        },
        {
          key: 'Qualification2',
          label: 'Secondary qualification',
        },
      ]}
    />
  </ActiveFilter>
)

export default GovPersonnelList



// WEBPACK FOOTER //
// ./src/personnel/details/gov-personnel/views/gov-personnel-list.jsx